import Contact from './contact'
import Location from './location'
import Username from './username'

/**
 * @author  Peter Collins /github.com/chimdipetercollins
 * @alias  Equipment
 */

// This class initializes the logic for managing equipment data

class Equipment {
    /**
     * @param   description: String
     * @param   make: String
     * @param   model: String
     * @param   type: String
     */ 
    constructor(object) {
        this._typeof = 'equipment'

        if (object) {
            this._description = object.description
            this._make = object.make
            this._model = object.model
            this._type = object.type
        }

        this._Contact = new Contact()
        this._Location = new Location
        this._Username = new Username()
    }

    // getters

    get description() {
        return this._description
    }

    get make() {
        return this.make
    }

    get model() {
        return this.model
    }

    get type() {
        return this.type
    }

    // setters

    /**
     * @param {String} value
     */
    set setDescription(value) {
        this._description = value
    }
}

export default Equipment
